import React, { useState } from 'react';
import './SearchBar.css';

function SearchBar({ onSearch, onTypeChange, loading }) {
  const [query, setQuery] = useState('');
  const [searchType, setSearchType] = useState('transaction');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query.trim(), searchType);
    }
  };

  const handleTypeChange = (type) => {
    setSearchType(type);
    if (onTypeChange) {
      onTypeChange(type);
    }
  };

  const exampleTx = '3e3b5b9e6f5c8f5e3b5b9e6f5c8f5e3b5b9e6f5c8f5e3b5b9e6f5c8f5e3b5b9e';
  const exampleAddress = '1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa';

  return (
    <div className="search-bar">
      <form onSubmit={handleSubmit}>
        <div className="search-type-selector">
          <button
            type="button"
            className={searchType === 'transaction' ? 'active' : ''}
            onClick={() => handleTypeChange('transaction')}
          >
            📝 Transaktion
          </button>
          <button
            type="button"
            className={searchType === 'address' ? 'active' : ''}
            onClick={() => handleTypeChange('address')}
          >
            📍 Adresse
          </button>
        </div>

        <div className="search-input-container">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={
              searchType === 'transaction'
                ? 'Bitcoin Transaction ID eingeben...'
                : 'Bitcoin Adresse eingeben...'
            }
            disabled={loading}
          />
          <button type="submit" disabled={loading || !query.trim()}>
            {loading ? '⏳' : '🔍'} Suchen
          </button>
        </div>

        <div className="search-hint">
          <small style={{color: '#888'}}>
            {searchType === 'transaction' 
              ? '💡 Wähle unten den Trace-Modus und die Tiefe'
              : '💡 Wähle unten die Anzahl Transaktionen und den Zeitraum'
            }
          </small>
        </div>

        <div className="search-examples">
          <small>
            Beispiele:{' '}
            <button
              type="button"
              className="example-link"
              onClick={() => {
                handleTypeChange('address');
                setQuery(exampleAddress);
              }}
            >
              Genesis Adresse
            </button>
          </small>
        </div>
      </form>
    </div>
  );
}

export default SearchBar;
